'use strict';

import {
    PANELMANAGER_CLOSE_PANEL,
    PANELMANAGER_CLOSE_PANEL_FINISH
} from '../../constants';
import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';
import PanelPropsDialog from '~/frontend/src/components/base/dialogs/PanelPropsDialog';
import cancelRequests from '~/frontend/src/actions/ajax/cancelRequests';
import clearAjaxError from '~/frontend/src/actions/ajax/clearAjaxError';
import clearAjaxErrorForSubpanels from '~/frontend/src/actions/ajax/clearAjaxErrorForSubpanels';
import {
    clearElusiveData,
    clearElusiveDataForSubpanels
} from '~/frontend/src/actions/elusiveData';
import {
    panelClasses,
    PanelType,
    PanelClass
} from '~/frontend/src/components/base/page/PageTabPanel/definitions';
import {getPanelProps} from '~/frontend/src/components/base/page/PageTabPanel/utilities';


export type ClosePanelAction = {
    type : typeof PANELMANAGER_CLOSE_PANEL,
    panelKey : string
};
export type ClosePanelFinishAction = {
    type : typeof PANELMANAGER_CLOSE_PANEL_FINISH,
    panelKey : string
};

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 */
const closePanel = ( panelKey : string ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<void> => {
    const panelConfig         = getPanelProps( panelKey ),
          panelProps          = panelConfig?.panelProps,
          panelType           = panelProps?.panelType,
          PanelComponentClass = panelType ? panelClasses[ panelType as PanelType ] as unknown as PanelClass : undefined;

    dispatch( {
        type: PANELMANAGER_CLOSE_PANEL,
        panelKey
    } );

    // has panel a close action -> dispatch it
    if ( PanelComponentClass?.onClosePanelAction ) {
        await dispatch( PanelComponentClass.onClosePanelAction( { ...panelProps, uid: panelKey, dontClearData: panelConfig.dontClearData ?? false } ) );
    }

    dispatch( cancelRequests( panelKey ) );
    dispatch( clearAjaxError( panelKey ) );
    dispatch( clearAjaxErrorForSubpanels( panelKey ) );
    dispatch( clearElusiveData( panelKey ) );
    dispatch( clearElusiveDataForSubpanels( panelKey ) );

    // has PanelPropsDialog a close action -> dispatch it
    if ( PanelPropsDialog?.onClosePanel ) {
        dispatch( PanelPropsDialog?.onClosePanel( panelKey ) );
    }

    delete global.data[ panelKey ];
    delete global.data[ panelKey + '-meta' ];

    dispatch( {
        type: PANELMANAGER_CLOSE_PANEL_FINISH,
        panelKey
    } );
}
export type ClosePanel = typeof closePanel;

export default closePanel;
